import React from 'react'
import clsx from 'clsx'
import { classToFComponent, type FCClassContext, ViewSlot } from 'cube-react'
import { BrModal, type BrModalProps } from '@govbr-ds/react-components'
import { DialogScope } from '../main.scope'

import Sel from '@/shared/view/CssSelectors'

export type DialogProps = {
    scope: DialogScope
}

export class DialogViewClass implements FCClassContext<DialogProps> {
    scope!: DialogScope

    render({ scope }: DialogProps) {
        this.scope = scope

        const brModalProps: BrModalProps = { isOpen: true }
        brModalProps.title = scope.title
        brModalProps.minWidth = scope.minWidth
        brModalProps.minHeight = scope.minHeight
        brModalProps.height = scope.height
        brModalProps.width = scope.width
        brModalProps.keepOpenOnPrimaryAction = scope.keepOpenOnPrimaryAction
        brModalProps.keepOpenOnSecondaryAction = scope.keepOpenOnSecondaryAction
        brModalProps.focusOnPrimaryAction = scope.focusOnPrimaryAction
        brModalProps.focusOnSecondaryAction = scope.focusOnSecondaryAction
        brModalProps.primaryAction = scope.primaryAction
        brModalProps.secondaryAction = scope.secondaryAction
        brModalProps.onClose = this.scope.onClose

        return (
            <div className={clsx(Sel.placeHolder, Sel.primeiroBrCardNoShadow)}>
                <BrModal {...brModalProps}>
                    <div className={Sel.brModalBody}>
                        <ViewSlot scope={scope.content} />
                    </div>
                </BrModal>
            </div>
        )
    }
}

export default classToFComponent<DialogProps>(DialogViewClass)
